import React, { useEffect, useState } from 'react';
import { Keyboard, Text } from 'react-native';
import { TextInput, View } from 'react-native-web';
import { hashtag } from '../../../utils/DictionaryManagementUtils';

//= ========================================================================

const ColorBar = ({
  globJSON, updateColor, colorId, avatarColor,
}) => {
  const [color, setColor] = useState(globJSON.configurations.theme.colors[colorId].toUpperCase());
  const [displayText, setDisplayText] = useState(color.substr(1));
  const [isOnFocus, setIsOnFocus] = useState(false);

  const myStyles = {
    container: {
      flexDirection: 'row',
      borderRadius: 4,
      border: isOnFocus ? 'solid 2px #00558c' : 'solid 1px #e2e8f0',
      overflow: 'hidden',
    },
    colorSquare: {
      height: 36,
      width: 48,
      borderLeft: 'solid 1px #e2e8f0',
      backgroundColor: color,
    },
    colorInput: {
      width: 60,
      outline: 'none',
      marginHorizontal: 4,
      color: displayText.length === 0 ? '#e2e8f0' : '#001a2f',
    },
    hashtag: {
      margin: 'auto',
      paddingStart: 10,
      color: '#e2e8f0',
    },

  };

  const isDeleteColor = (val) => (avatarColor && val.length === 0);
  const isValidColor = (val) => (val.length === 6 && val.match(/^[0-9a-fA-F]+$/)) || isDeleteColor(val);

  const setDisplayTextByColor = (colorFull) => {
    setDisplayText(colorFull.toUpperCase().substr(1));
    setColor(colorFull);
  };

  useEffect(() => {
    setDisplayTextByColor(globJSON.configurations.theme.colors[colorId]);
  }, [globJSON.configurations.theme.colors[colorId]]);

  return (
    <View style={myStyles.container}>
      <Text style={myStyles.hashtag}>{hashtag}</Text>
      <TextInput
        style={myStyles.colorInput}
        placeholder="FFFFFF"
        value={displayText}
        multiline={false}
        selectTextOnFocus
        autoCorrect={false}
        onFocus={() => {
          setIsOnFocus(true);
        }}
        maxLength={6}
        onBlur={() => {
          if (isOnFocus) {
            setIsOnFocus(false);
          }
          if (!isValidColor(displayText)) {
            setDisplayTextByColor(color);
          }
        }}
        blurOnSubmit={false}
        onChangeText={(newText) => {
          setDisplayText(newText.toUpperCase());
          if (isValidColor(newText)) {
            const newColor = `#${newText}`;
            setColor(newColor);
            updateColor(colorId, newColor);
          }
        }}
        onKeyPress={(e) => {
          if (e.nativeEvent.key === 'Enter') {
            Keyboard.dismiss();
            if (!isValidColor(displayText)) {
              setDisplayTextByColor(color);
            }
          }
        }}
      />
      <View style={myStyles.colorSquare} />
    </View>
  );
};
export default ColorBar;
